import React from "react";
import { Box, Typography } from "@mui/material";
import useFooterMode from "../hooks/useFooterMode";
import { DASHBOARD_FOOTER_HEIGHT } from "../helpers/layoutConstants";

const DashboardFooter = () => {
  const mode = useFooterMode(DASHBOARD_FOOTER_HEIGHT);
  return (
    <Box
      sx={{
        width: "100%",
        height: `${DASHBOARD_FOOTER_HEIGHT}px`,
        background: "#F1F7FA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...(mode === "fixed"
          ? { position: "fixed", bottom: 0, left: 0, zIndex: 9 }
          : {}),
      }}
    >
      <Typography
        sx={{
          color: "#000000",
          fontWeight: 400,
          fontSize: "16px",
          textAlign: "center",
        }}
      >
        Copyright © 2024 Elevate Aviation. All rights reserved.
      </Typography>
    </Box>
  );
};

export default DashboardFooter;
